// @ts-nocheck

// Shared payment terms options used by Invoices and Bills
// id: unique identifier; name: label; days: number of days to add (null for Custom/manual)
export const PAYMENT_TERMS = [
  { id: 0, name: 'Custom', days: null },
  { id: 1, name: '7 days', days: 7 },
  { id: 2, name: '15 days', days: 15 },
  { id: 3, name: '30 days', days: 30 },
  { id: 4, name: '45 days', days: 45 },
  { id: 5, name: '60 days', days: 60 },
  { id: 6, name: '90 days', days: 90 },
  { id: 7, name: '120 days', days: 120 },
];

